<div class="wrapper animated fadeIn">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <div class="btn-group pull-right">
                        <ol class="breadcrumb hide-phone p-0 m-0">
                            <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                            <li class="breadcrumb-item"><a href="#">Configuracion</a></li>
                            <li class="breadcrumb-item"><a href="#">Business</a></li>
                        </ol>
                    </div>
                    <h4 class="page-title">Business</h4>
                </div>
            </div>
        </div>
        <app-info-user></app-info-user>
        <app-company-list></app-company-list>
    </div>
</div>